import React, { Component } from "react"
import styled from "styled-components"
import { Container } from "styled-bootstrap-grid"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"
import Slider from "react-slick"
import CarouselIndicator from "../CarouselIndicator"
import DetailCard from "./DetailCard"
import ContentContainer from "../Engagement/ContentContainer"
import { withTranslation, Trans } from "gatsby-plugin-react-i18next"

const DetailsBlock = styled.div`
  display: ${(props) => (props.$desktop ? "none" : "block")};
  padding-top: 45px;
  padding-bottom: 30px;
  background: ${colors.white};

  @media (min-width: ${breakpoints.lg}) {
    display: ${(props) => (props.$desktop ? "block" : "none")};
    padding-top: 66px;
    padding-bottom: 60px;
    background: ${colors.white};
  }
`

const CarouselIndicatorContainer = styled.div`
  padding-top: 10px;
`

const DetailsRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledSlider = styled(Slider)`
  .slick-slide {
    outline: none;
  }
`

class PreFooter extends Component {
  state = {
    slideIndex: 0,
  }

  changeSlide(index) {
    this.slider.slickGoTo(index)
  }

  render() {
    const { slideIndex } = this.state
    const { isEngagement, t, discontinued, archive } = this.props

    let settings = {
      dots: false,
      arrows: false,
      infinite: true,
      fade: false,
      swipe: true,
      swipeToSlide: true,
      draggable: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      initialSlide: 0,
      beforeChange: (_, next) => this.setState({ slideIndex: next }),
    }

    const detailsEngagement = [
      {
        title: t("prefooter.title.1"),
        text: t("prefooter.content.1"),
        linkLabel: t("prefooter.cta.label.1"),
        linkUrl: "/contact/",
      },
      {
        title: t("prefooter.title.2"),
        text: t("prefooter.content.2"),
        linkLabel: null,
        linkUrl: null,
      },
      {
        title: t("prefooter.title.3"),
        text: t("prefooter.content.3"),
        linkLabel: null,
        linkUrl: null,
      },
      {
        title: t("prefooter.title.4"),
        text: (
          <Trans i18nKey="prefooter.details.content.4">
            We accept secure payment methods including PayPal, American Express,
            debit or credit cards, and bank transfers (contact us at{" "}
            <a href={"mailto:info@kimai.com"}>info@kimai.com</a>). Flexible
            financing options like Klarna are available in the US, UK, France,
            and across the EU, allowing you to split payments over several
            months.
          </Trans>
        ),
        linkLabel: null,
        linkUrl: null,
      },
    ]

    const details = [
      {
        title: t("prefooter.details.title.1"),
        text: t("prefooter.details.content.1"),
        linkLabel: null,
        linkUrl: null,
        email: "info@kimai.com",
      },
      {
        title: t("prefooter.details.title.holidays"),
        text: discontinued
          ? t("prefooter.details.content.discontinued")
          : archive
            ? t("pdp.no_returns_archives")
            : t("prefooter.details.content.holidays"),
        linkLabel: t("prefooter.details.cta.label.holidays"),
        linkUrl: "/faq/",
      },
      {
        title: t("prefooter.details.title.3"),
        text: t("prefooter.details.content.3"),
        linkLabel: null,
        linkUrl: null,
      },
      {
        title: t("prefooter.details.title.4"),
        text: (
          <Trans i18nKey="prefooter.details.content.4">
            We accept secure payment methods including PayPal, American Express,
            debit or credit cards, and bank transfers (contact us at{" "}
            <a href={"mailto:info@kimai.com"}>info@kimai.com</a>). Flexible
            financing options like Klarna are available in the US, UK, France,
            and across the EU, allowing you to split payments over several
            months.
          </Trans>
        ),
        linkLabel: null,
        linkUrl: null,
      },
    ]

    return (
      <>
        {isEngagement ? (
          <React.Fragment>
            <DetailsBlock>
              <StyledSlider
                ref={(slider) => (this.slider = slider)}
                {...settings}
              >
                {detailsEngagement.map((detail, index) => {
                  return <DetailCard detail={detail} key={index} />
                })}
              </StyledSlider>
              <CarouselIndicatorContainer>
                <CarouselIndicator
                  current={slideIndex}
                  max={4}
                  changeSlide={this.changeSlide.bind(this)}
                  white={"true"}
                />
              </CarouselIndicatorContainer>
            </DetailsBlock>
            <DetailsBlock $desktop={1}>
              <Container>
                <ContentContainer>
                  <DetailsRow>
                    {detailsEngagement.map((detail, index) => {
                      return (
                        <DetailCard
                          detail={detail}
                          isFirst={index === 0}
                          key={index}
                        />
                      )
                    })}
                  </DetailsRow>
                </ContentContainer>
              </Container>
            </DetailsBlock>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <DetailsBlock>
              <StyledSlider
                ref={(slider) => (this.slider = slider)}
                {...settings}
              >
                {details.map((detail, index) => {
                  return <DetailCard detail={detail} key={index} />
                })}
              </StyledSlider>
              <CarouselIndicatorContainer>
                <CarouselIndicator
                  current={slideIndex}
                  max={4}
                  changeSlide={this.changeSlide.bind(this)}
                  white={"true"}
                />
              </CarouselIndicatorContainer>
            </DetailsBlock>
            <DetailsBlock $desktop={1}>
              <Container>
                <ContentContainer>
                  <DetailsRow>
                    {details.map((detail, index) => {
                      return (
                        <DetailCard
                          detail={detail}
                          isFirst={index === 0}
                          key={index}
                        />
                      )
                    })}
                  </DetailsRow>
                </ContentContainer>
              </Container>
            </DetailsBlock>
          </React.Fragment>
        )}
      </>
    )
  }
}

export default withTranslation()(PreFooter)
